<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Fusion Check</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter Fusion Breakpoints gene name.</div>
                    <mat-icon
                        matTooltip="Enter Fusion Breakpoints, e.g. 'chr15:75688603-chr11:6622666' or click 'Load Example' to get a basic example."
                        matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter Sequence Data, e.g. 'chr15:75688603-chr11:6622666' or click 'Load Example'"></textarea>
            </div>
            <div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div class="card-grid" *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header">
            <h2>{{element.name}}</h2>
        </div>
        <ul *ngIf="element['response']==200" style="margin-top: 10px;">
            <li> <span style="font-weight: bold;">Fusion In-Frame: </span> <span
                    [ngStyle]="{'color': (element['inframe']=='Out_of_Frame') ? 'red' : 'green'}">{{element['inframe']}}</span>
            </li>
            <li style="margin-top: 10px; font-weight: bold;">Breakpoint 1 - Info: {{element['i1_qid']}}</li>
            <ul>
                <li>Gene Name: {{element['i1_gene_name']}}</li>
                <li>Position In-Frame: <span
                        [ngStyle]="{'color': (element['i1_position_in_frame']=='Out_of_Frame') ? 'red' : 'green'}">{{element['i1_position_in_frame']}}</span>
                </li>
                <li>Position in triplett: {{element['i1_position_in_triplett']}}</li>
                <li>Strand: {{element['i1_strand']}}</li>
                <li>Target Exon: {{element['i1_target_exon']}}</li>
                <li>Used Transcript: {{element['i1_transcript']}}</li>
            </ul>
            <li style="margin-top: 10px; font-weight: bold;">Breakpoint 2 - Info: {{element['i2_qid']}}</li>
            <ul style="margin-bottom: 10px;">
                <li>Gene Name: {{element['i2_gene_name']}}</li>
                <li>Position In-Frame: <span
                        [ngStyle]="{'color': (element['i2_position_in_frame']=='Out_of_Frame') ? 'red' : 'green'}">{{element['i2_position_in_frame']}}</span>
                </li>
                <li>Position in triplett: {{element['i2_position_in_triplett']}}</li>
                <li>Strand: {{element['i2_strand']}}</li>
                <li>Target Exon: {{element['i2_target_exon']}}</li>
                <li>Used Transcript: {{element['i2_transcript']}}</li>
            </ul>
        </ul>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
        </ul>
    </div>
</div>